// Single source of truth for the backend base URL and every endpoint the
// frontend calls. Nothing outside this file should hardcode a URL path.
//
// BASE_URL is relative on purpose: the Arkii API ships with no CORS headers
// at all, so a browser can't call https://api.arkii.ai directly from any
// other origin. Instead we call same-origin "/api/v1/..." and let a proxy
// forward it server-side — CRA's dev-server "proxy" field in package.json
// during development, and the public/_redirects rewrite on Netlify in
// production. Neither hop is visible to the browser, so CORS never applies.

export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || "/api/v1",
  TIMEOUT: 30000,
};

export const API_ENDPOINTS = {
  USER: {
    SIGNUP: "/user/signup/",
    VERIFY_EMAIL: "/user/verify-email/",
    RESEND_VERIFICATION: "/user/resend-verification/",
    LOGIN: "/user/login/",
    GOOGLE: "/user/google/",
    TOKEN_REFRESH: "/user/token/refresh/",
    LOGOUT: "/user/logout/",
    ME: "/user/me/",
    ONBOARD: "/user/onboard/",
    PASSWORD_CHANGE: "/user/password/change/",
  },
  SUBSCRIPTION: {
    SUBSCRIBE: "/subscription/subscribe/",
    ME: "/subscription/me/",
  },
  ORGANIZATION: {
    DETAIL: (id) => `/organization/${id}/`,
  },
  CREDIT: {
    BALANCE: "/credit/balance/",
    LEDGER: "/credit/ledger/",
  },
  TRANSCRIPTION: {
    DETAIL: (id) => `/transcription/${id}/`,
    HISTORY: "/transcription/history/",
  },
  UPLOAD: {
    LIST: "/uploads/",
    DETAIL: (id) => `/uploads/${id}/`,
  },
  PROJECT: {
    LIST: "/project/",
    DETAIL: (id) => `/project/${id}/`,
  },
  TRANSLATION: {
    TRANSLATE: "/translation/translate/",
    DETAIL: (id) => `/translation/${id}/`,
    LIST: "/translation/",
  },
  REVIEW: {
    TRIGGER: "/review/review/",
    DETAIL: (id) => `/review/${id}/`,
    SUGGESTIONS: "/review/suggestions/",
    SUGGESTION_DETAIL: (id) => `/review/suggestions/${id}/`,
  },
  EXPORT: {
    VIDEO: "/export/video/",
    VIDEO_DETAIL: (id) => `/export/video/${id}/`,
  },
  NOTIFICATION: {
    LIST: "/notification/",
    UNREAD_COUNT: "/notification/unread-count/",
    DETAIL: (id) => `/notification/${id}/`,
    READ_ALL: "/notification/read-all/",
  },
};
